import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { getUserLabel } from '@app/features/users/user-label-pipe';
import { User, UserRole } from '@app/features/users/user.model';
import { RUNTIME_CONFIG } from '@environments/runtime-config.token';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { canonicalRoles } from './role-names';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private http = inject(HttpClient);

  private url = `${inject(RUNTIME_CONFIG).apiUrl}/users`;
  private _allUsersSubject = new BehaviorSubject<User[]>([]);

  constructor() {
    this.refreshAllUsers();
  }

  get allUsers$(): Observable<User[]> {
    return this._allUsersSubject.asObservable();
  }

  refreshAllUsers(): void {
    this.http.get<User[]>(this.url).subscribe((users) => {
      // Un compte qui porte encore l'ancien nom d'un rôle de CDT vaut le nouveau (cadrage 2026-031).
      this._allUsersSubject.next(
        users.map((user) => ({ ...user, realmRoles: canonicalRoles<UserRole>(user.realmRoles) })),
      );
    });
  }

  get allUsers(): Observable<User[]> {
    return this._allUsersSubject.asObservable();
  }

  listByRole(roles: UserRole[]): Observable<User[]> {
    return this.allUsers$.pipe(
      map((users) =>
        users
          .filter((user) => roles.some((role) => user.realmRoles.includes(role)))
          .sort((userA, userB) =>
            getUserLabel(userA).localeCompare(getUserLabel(userB), 'fr', { sensitivity: 'base' }),
          ),
      ),
    );
  }
}
